export const statsData = {
    databases_count: '126',
    sanctioned_individuals: '21,124',
    sanctioned_entities: '10,743',
    sanctioned_vehicles: '1,420',
    sources_count: '8',
    last_updated: new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    }),
};
